module.exports = __webpack_public_path__ + "static/media/vk.bf2e2df0.svg";